<template>
  <div v-if="display">
    <h1 class="page-title"><i class="fal fa-desktop-alt"></i> Inställningar</h1>
    <h3>Gränssnitt</h3>
    <div class="columns">
      <div class="column is-one-quarter">
        <label class="label">Textstorlek</label>
        <div class="select">
          <select v-model="userSettings.fontSize" @change="setFontSize(userSettings.fontSize)">
            <option value="16">Normal</option>
            <option value="18">Stor</option>
            <option value="20">Gigantisk</option>
          </select>
        </div>
      </div>
    </div>

    <h3>Antal rader</h3>
    <div class="columns">
      <div class="column is-one-quarter">
        <label class="label">Ärendelistor</label>
        <div class="select">
          <select v-model="userSettings.itemsPerPageProjects">
            <option value="0">0 (visa alla)</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
      </div>
    </div>
    <!-- <div class="columns">
      <div class="column is-one-quarter">
        <label class="label">Uppgiftslistor</label>
        <div class="select">
          <select v-model="userSettings.itemsPerPageWorkOrders">
            <option value="0">0 (visa alla)</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
      </div>
    </div> -->
    <!-- <div class="columns">
      <div class="column is-one-quarter">
        <label class="label">Övriga listor</label>
        <div class="select">
          <select v-model="userSettings.itemsPerPageDefault">
            <option value="0">0 (visa alla)</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
      </div>
    </div> -->

    <!--
    <h3>Tjänster</h3>
    <label class="label">Status Alla visar</label>
    <div><label><input type="checkbox" :checked="getValue('Planned')" @change="check('Planned')" /> Planerad</label></div>
    <div><label><input type="checkbox" :checked="getValue('Started')" @change="check('Started')" /> Pågående</label></div>
    <div><label><input type="checkbox" :checked="getValue('Registered')" @change="check('Registered')" /> Registrerad</label></div>
    <div><label><input type="checkbox" :checked="getValue('Invoiced')" @change="check('Invoiced')" /> Fakturerad</label></div>
    <div><label><input type="checkbox" :checked="getValue('Cancelled')" @change="check('Cancelled')" /> Makulerad</label></div>
    <br>
    -->

    <div class="columns">
      <div class="column is-one-quarter">
      <label class="label">Göm bilder i listor</label>
      <input id="hide-project-images" type="checkbox" v-model="userSettings.hideProjectImages" class="switch is-rounded">
      <label for="hide-project-images" class="label"></label>
      </div>
    </div>

    <template v-if="hasRole('Broker') || hasRole('Staff')">
      <h3>Notifikationer (email)</h3>
      <!-- <div class="columns">
        <div class="column is-one-quarter">
        <label class="label">Projekt skapat</label>
        <input id="email-service-updates" type="checkbox" v-model="userSettings.projectCreated" class="switch is-rounded">
        <label for="email-service-updates" class="label"></label>
        </div>
      </div> -->

      <div class="columns">
        <div class="column is-one-quarter">
        <label class="label">Ärendeuppdateringar</label>
        <input id="email-service-updates" type="checkbox" v-model="userSettings.emailServiceUpdates" class="switch is-rounded">
        <label for="email-service-updates" class="label"></label>
        </div>
      </div>

      <div class="columns">
        <div class="column is-one-quarter">
        <label class="label">Dokument uppladdade</label>
        <input id="email-documents-uploaded" type="checkbox" v-model="userSettings.emailDocumentsUploaded" class="switch is-rounded">
        <label for="email-documents-uploaded" class="label"></label>
        </div>
      </div>

      <div class="columns">
        <div class="column is-one-quarter">
        <label class="label">Dokument skapade</label>
        <input id="email-documents-created" type="checkbox" v-model="userSettings.emailDocumentsCreated" class="switch is-rounded">
        <label for="email-documents-created" class="label"></label>
        </div>
      </div>

      <div class="columns">
        <div class="column is-one-quarter">
        <label class="label">Ny kommentar</label>
        <input id="email-new-comment" type="checkbox" v-model="userSettings.emailNewComment" class="switch is-rounded">
        <label for="email-new-comment" class="label"></label>
        </div>
      </div>

      <div class="columns" v-if="hasPermission('CoordinateProjects')">
        <div class="column is-one-quarter">
        <label class="label">Nya projekt att koordinera</label>
        <input id="email-project-to-coordinate" type="checkbox" v-model="userSettings.emailProjectToCoordinate" class="switch is-rounded">
        <label for="email-project-to-coordinate" class="label"></label>
        </div>
      </div>
    </template>

    <button class="button is-primary" @click="save">Spara</button>
    <slideout-panel />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      display: false,
      loadedFontSize: null,
      userSettings: {}
    }
  },
  computed: {
    ...mapGetters('auth', ['hasPermission', 'hasRole'])
  },

  methods: {
    ...mapActions('userSettings', ['getCurrentUserSettings', 'saveCurrentUserSettings']),

    getValue (key) {
      return this.userSettings.projectStatusAllShows.some(x => x === key)
    },

    check (key) {
      const index = this.userSettings.projectStatusAllShows.indexOf(key)
      if (index > -1) {
        this.userSettings.projectStatusAllShows.splice(index, 1)
      } else {
        this.userSettings.projectStatusAllShows.push(key)
      }
    },

    save () {
      this.saveCurrentUserSettings(this.userSettings).then(userSettings => {
        this.userSettings = userSettings
        this.loadedFontSize = this.userSettings.fontSize
      })
    },

    setFontSize (fontSize) {
      let previewElement = document.getElementById('html')
      previewElement.style.fontSize = fontSize + 'px'
    }
  },

  mounted () {
    this.getCurrentUserSettings().then(userSettings => {
      this.userSettings = userSettings
      this.loadedFontSize = userSettings.fontSize
      this.display = true
    })
  },

  beforeRouteLeave (to, from, next) {
    this.setFontSize(this.loadedFontSize)
    next()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/PreferencesPage.vue